/**
 * Icon lookup for condition data sources — the marker icon rendered by
 * Pluma's ConditionViewerItem for each condition type.
 *
 * Pure data with no React dependency, so it sits here rather than under
 * `components/`, alongside the other shared label and icon maps.
 */

import { type IconProps } from '@customerio/pluma-components/react';

type IconName = IconProps['name'];

export const DATA_SOURCE_TYPE_ICON = {
  attribute: 'person',
  event: 'trigger-event',
  segment: 'segment',
  device: 'mobile',
  // Pluma has no url-parameters icon, so a page view is marked with a link.
  pageview: 'link',
  screenview: 'modal-bottom',
  form: 'form',
  message: 'email',
  email: 'email',
  push: 'mobile',
  in_app: 'in-app',
  sms: 'sms',
  slack: 'slack',
  webhook: 'webhook',
  inbound: 'sms',
  opt_out: 'sms',
  relationship: 'connections',
  subscription: 'newsletter',
  object: 'object',
  value: 'database',
  unknown: 'critical',
} satisfies Record<DataSourceType, IconName>;

export type DataSourceType =
  | 'attribute'
  | 'event'
  | 'segment'
  | 'device'
  | 'pageview'
  | 'screenview'
  | 'form'
  | 'message'
  | 'email'
  | 'push'
  | 'in_app'
  | 'sms'
  | 'slack'
  | 'webhook'
  | 'inbound'
  | 'opt_out'
  | 'relationship'
  | 'subscription'
  | 'object'
  | 'value'
  | 'unknown';
